
import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLinkActive } from '@angular/router';
import { TenantService } from '@dworkflow/shared/services/tenant.service';
import { guid } from '@dworkflow/shared/utility/guid';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dworkflow-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [MatButtonModule, RouterLinkActive, MatIconModule, TranslateModule]
})
export class FooterComponent {
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private tenantService = inject(TenantService);

  readonly useRouter = input(true);
  readonly showSupportInformationenButton = input(true);
  translationsLoaded: boolean;

  constructor() {
    const translate = inject(TranslateService);

    // Prüfung ob Translations geladen sind, da die Komponente auch auf der Login-Seite angezeigt werden kann.
    // Dort sind die Translations aufgrund der noch nicht erfolgten Authentifizierung nicht verfügbar.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.translationsLoaded = !!translate.translations.config.Texte;
  }

  openSupportInfoModal(): void {
    import(
      '@dworkflow/footer/support-informationen-modal/support-informationen-modal.component'
    ).then(c => {
      const urlFragments = this.router.url.split('/');
      let workflowId = null;
      if (urlFragments.length > 3 && urlFragments[2] === 'workflows') {
        workflowId = urlFragments[3] as guid;
      }

      this.dialog.open(c.SupportInformationenModalComponent, {
        data: { workflowId },
        disableClose: true,
        ariaLabel: 'Supportinformationen',
      });
    });
  }

  redirectTo(url: string): void {
    this.tenantService.redirectUrl(url);
  }
}
